import { useState } from "react";

import { useAuth } from "../components";

import {
  Box,
  Button,
  CircularProgress,
  FormHelperText,
  Grid2,
  Paper,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import styled from "styled-components";
import logoImg from "../assets/bellatchau.png";
import background from "../assets/camera.jpg";
import Image from "../components/data-display/Image.component";
import { emailRegex } from "../utils";

interface Inputs {
  email: string;
  password: string;
}

function Admin() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();

  const authProvider = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    setLoading(true);
    authProvider
      ?.signUser({
        email: data.email,
        senha: data.password,
      })
      .then((message) => {
        setLoading(false);
        navigate("/admin/dashboard");
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar("Email ou a senha está incorreto!", {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <StyledGridContainer container>
      <ImageSide size={{ sm: 4, md: 7, xs: false }} />
      <Grid2
        size={{ xs: 12, sm: 8, md: 5 }}
        component={Paper}
        elevation={6}
        square
      >
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Image
            alt="Image banner"
            src={logoImg}
            height="90px"
            width="90px"
            style={{ marginBottom: theme.spacing(2), borderRadius: "50%" }}
          />
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit(onSubmit)}
            sx={{ mt: 1, width: "100%" }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              error={errors.email ? true : false}
              id="email"
              label="Email"
              autoComplete="email"
              autoFocus
              {...register("email", {
                required: "O campo não pode estar em branco",
                pattern: {
                  value: emailRegex,
                  message: "Por favor coloque @ no campo email",
                },
              })}
            />
            {errors.email && (
              <FormHelperText error>{errors.email.message}</FormHelperText>
            )}
            <TextField
              margin="normal"
              required
              fullWidth
              error={errors.password ? true : false}
              label="Senha"
              type="password"
              id="password"
              autoComplete="current-password"
              {...register("password", {
                required: "O campo não pode estar em branco",
              })}
            />
            {errors.password && (
              <FormHelperText error>{errors.password.message}</FormHelperText>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              {loading ? (
                <CircularProgress size={25} color="inherit" />
              ) : (
                "Entrar"
              )}
            </Button>
          </Box>
        </Box>
      </Grid2>
    </StyledGridContainer>
  );
}

const StyledGridContainer = styled(Grid2)`
  width: "100%";
  height: 100vh;
`;

const ImageSide = styled(Grid2)`
  background-image: url(${background});
  background-size: cover;
`;

export default Admin;
